import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

import {
  ADD_CLICK_CONVERSION_PIXEL,
  ADD_CLICK_IMPORT_CONVERSION_PIXEL,
  DELETE_CLICK_CONVERSION_LOG,
  DELETE_CLICK_CONVERSION_PIXEL,
  DOWNLOAD_BULK_CONVERSIONS_FILE,
  GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS,
  GET_CALL_CONVERSION_PIXELS_AGG_PROFILES,
  GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES,
  GET_CLICK_CONVERSION_LOGS,
  GET_CLICK_CONVERSION_LOG_BY_ID,
  GET_CLICK_CONVERSION_PIXELS, GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS, GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS, GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES, GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS, GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES, GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES, GET_PRESIGNED_URL, GET_STATUS_OF_LOGS_BY_IDS, MODIFY_CLICK_CONVERSION_PIXELS, UPLOAD_FILE_TO_URL,
  GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3,
  GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3,
  GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3
} from "./actionTypes"

import {
  addClickConversionPixelError,
  addClickConversionPixelSuccess,
  addClickImportConversionPixelError,
  addClickImportConversionPixelSuccess,
  deleteClickConversionLogsError,
  deleteClickConversionLogsSuccess,
  deleteClickConversionPixelError,
  deleteClickConversionPixelSuccess,
  downloadBulkConversionsError,
  downloadBulkConversionsFileSuccess,
  getCallConversionPixelsAggCampaignsError,
  getCallConversionPixelsAggCampaignsSuccess,
  getCallConversionPixelsAggProfilesError,
  getCallConversionPixelsAggProfilesSuccess,
  getCallConversionPixelsAggSourceTypesError,
  getCallConversionPixelsAggSourceTypesSuccess,
  getClickConversionLogByIdError,
  getClickConversionLogByIdSuccess,
  getClickConversionLogsError,
  getClickConversionLogsSuccess,
  getClickConversionPixelsAggAdGroupsError,
  getClickConversionPixelsAggAdGroupsSuccess,
  getClickConversionPixelsAggCampaignsError,
  getClickConversionPixelsAggCampaignsSuccess,
  getClickConversionPixelsAggSourceTypesError,
  getClickConversionPixelsAggSourceTypesSuccess,
  getClickConversionPixelsError,
  getClickConversionPixelsSuccess,
  getLeadConversionPixelsAggCampaignsError,
  getLeadConversionPixelsAggCampaignsSuccess,
  getLeadConversionPixelsAggProfilesError,
  getLeadConversionPixelsAggProfilesSuccess,
  getLeadConversionPixelsAggSourceTypesError,
  getLeadConversionPixelsAggSourceTypesSuccess,
  getStatusOfLogsByIdsError,
  getStatusOfLogsByIdsSuccess,
  modifyClickConversionPixelsError,
  modifyClickConversionPixelsSuccess,
  uploadFileToUrl,
  getConversionPixelsAggAdGroupsV3Success,
  getConversionPixelsAggAdGroupsV3Error,
  getConversionPixelsAggSourceTypesV3Success,
  getConversionPixelsAggSourceTypesV3Error,
  getConversionPixelsAggCampaignsV3Success,
  getConversionPixelsAggCampaignsV3Error
} from "./actions"

import { genericDeleteRequest, genericGetRequest, genericGetRequest_2, genericPostRequest, genericPutRequest, getPresignedUrl, postCreateConversions, postFileToPresignedUrl } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { getCurrentBrandFromLocalStorage } from "helpers/sf_utils"
import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert"
import { REQUEST_TOO_LARGE_ERROR } from "helpers/errors"

function* onGetClickConversionPixels() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/click_conversion_pixels`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'brand-id': getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getClickConversionPixelsSuccess(response))
  } catch (error) {
    yield put(getClickConversionPixelsError(error))
  }
}

function* onUpdateClickConversionPixels(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/click_conversion_pixels/${action.payload.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'brand-id': getCurrentBrandFromLocalStorage()?.id
        }
      }
    )
    yield put(modifyClickConversionPixelsSuccess(response))
  } catch (error) {
    yield put(modifyClickConversionPixelsError(error))
  }
}

function* onAddClickConversionPixel(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/click_conversion_pixels/`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'brand-id': action.payload.brand_id
        }
      }
    )
    yield put(addClickConversionPixelSuccess(response))
  } catch (error) {
    yield put(addClickConversionPixelError(error))
  }
}


function* onDeleteClickConversionPixel(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/click_conversion_pixels/${action.payload}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'brand-id': getCurrentBrandFromLocalStorage()?.id
        }
      }
    )
    yield put(deleteClickConversionPixelSuccess(response))
  } catch (error) {
    yield put(deleteClickConversionPixelError(error))
  }
}

function* onGetClickConversionPixelAggAdGroups(action) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/click_conversion_pixels_aggregated`,
      { ...(action.payload?.queryParams || {}), group_by_param: 'ad_group_id' },
      {
        Authorization: JSON.parse(user_auth).user.token,
        "account-id": JSON.parse(user_auth).user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getClickConversionPixelsAggAdGroupsSuccess(response))
  } catch (error) {
    yield put(getClickConversionPixelsAggAdGroupsError(error))
  }
}

function* onGetClickConversionPixelAggCampaigns(action) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/click_conversion_pixels_aggregated`,
      { ...(action.payload?.queryParams || {}), group_by_param: 'campaign_id' },
      {
        Authorization: JSON.parse(user_auth).user.token,
        "account-id": JSON.parse(user_auth).user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getClickConversionPixelsAggCampaignsSuccess(response))
  } catch (error) {
    yield put(getClickConversionPixelsAggCampaignsError(error))
  }
}

function* onGetLeadConversionPixelAggCampaigns(action) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_conversion_pixels_aggregated`,
      { ...(action.payload?.queryParams || {}), group_by_param: 'campaign_id' },
      {
        Authorization: JSON.parse(user_auth).user.token,
        "account-id": JSON.parse(user_auth).user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getLeadConversionPixelsAggCampaignsSuccess(response))
  } catch (error) {
    yield put(getLeadConversionPixelsAggCampaignsError(error))
  }
}

function* onGetCallConversionPixelAggCampaigns(action) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/call_conversion_pixels_aggregated`,
      { ...(action.payload?.queryParams || {}), group_by_param: 'campaign_id' },
      {
        Authorization: JSON.parse(user_auth).user.token,
        "account-id": JSON.parse(user_auth).user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getCallConversionPixelsAggCampaignsSuccess(response))
  } catch (error) {
    yield put(getCallConversionPixelsAggCampaignsError(error))
  }
}

function* onGetClickConversionPixelAggSourceTypes(action) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/click_conversion_pixels_aggregated`,
      { ...(action.payload?.queryParams || {}), group_by_param: 'source_type_id' },
      {
        Authorization: JSON.parse(user_auth).user.token,
        "account-id": JSON.parse(user_auth).user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getClickConversionPixelsAggSourceTypesSuccess(response))
  } catch (error) {
    yield put(getClickConversionPixelsAggSourceTypesError(error))
  }
}

function* onAddClickImportConversionPixel(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const res = yield call(
      postCreateConversions,
      `${AppConfiguration.BACKEND_URL}/api/v1/conversions_bulk`,
      {
        payload: action.payload,
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'brand-id': action.payload?.brand_id
        },
      }
    )
    yield put(addClickImportConversionPixelSuccess(res))
  } catch (error) {
    yield put(addClickImportConversionPixelError(error))
  }
}

function* onGetClickConversionLogs(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/click_conversion_logs`,
      {...action?.payload?.queryParams || ""}, // no query parameters
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'brand-id': action?.payload?.brand_id || getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getClickConversionLogsSuccess(response))
  } catch (error) {
    yield put(getClickConversionLogsError(error))
  }
}

function* onGetClickConversionLogById(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/click_conversion_logs/${action.payload?.id}`,
      {...action?.payload?.queryParams || ""}, // no query parameters
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'brand-id': action?.payload?.brand_id || getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getClickConversionLogByIdSuccess(response))
  } catch (error) {
    yield put(getClickConversionLogByIdError(error))
  }
}

function* onGetPresignedUrl({payload, history}) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      getPresignedUrl,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_presigned_url`,
      {
        payload: payload,
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'brand-id': payload.brand_id
        }
      }
    )
    ToastAlert.fire({ title: "Conversion bulk import is currently in progress. A report will be sent to your email upon completion.", icon: ToastAlertIconType.OK })
    history.push(`/settings/${payload.brand_id}/click-conversion-uploads`)
    yield put(uploadFileToUrl({...response.urlData, ...response.logData, ...payload}))
    yield put(addClickImportConversionPixelSuccess(response.logData))
  } catch (error) {
    if (error.name == REQUEST_TOO_LARGE_ERROR) {
      ToastAlert.fire({ title: error.message, icon: ToastAlertIconType.WARNING})
    } else {
      ToastAlert.fire({ title: "Conversion bulk import failed", icon: ToastAlertIconType.ERROR})
    }
    yield put(addClickConversionPixelError(error))
  }
}

function* onPostFileToPresignedURL(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      postFileToPresignedUrl,
      `${AppConfiguration.BACKEND_URL}/api/v1/click_conversion_logs/${action.payload?.id}`,
      {
        payload: action.payload,
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'brand-id': action.payload.brand_id
        }
      }
    )
  } catch (error) {
    yield put(addClickConversionPixelError(error))
  }
}

function* onGetClickConversionLogsStatusByIds(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_status_of_logs_by_ids`,
      {ids: action?.payload?.ids || ""}, // no query parameters
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'brand-id': action?.payload?.brand_id || getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getStatusOfLogsByIdsSuccess(response))
  } catch (error) {
    yield put(getStatusOfLogsByIdsError(error))
  }
}

function* onDeleteClickConversionLog(action) {
  try {
    const isAsyncDeletionEnabled = action.payload?.isAsyncDeletionEnabled;
    if (isAsyncDeletionEnabled) {
      ToastAlert.fire({
        icon: ToastAlertIconType.OK,
        title: "Conversion upload log deletion has started. We'll notify through email once the deletion is completed"
      });
    }

    const user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/click_conversion_logs/${action.payload?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'brand-id': action?.payload?.brand_id || getCurrentBrandFromLocalStorage()?.id
        }
      }
    )
    yield put(deleteClickConversionLogsSuccess({ ...response, isAsyncDeletionEnabled }))
  } catch (error) {
    yield put(deleteClickConversionLogsError(error))
  }
}

function* onDownloadBulkConversionsFile(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/click_conversion_logs/${action?.payload?.conversion_log_id}/presigned_url`,
      {},
      {
        Authorization: user.token,
        'account-id': user.account_id,
      }
    )

    yield put(downloadBulkConversionsFileSuccess(action.payload))
    window.open(response?.signed_url, '_blank');
  } catch (error) {
    yield put(downloadBulkConversionsError(error, action.payload))
  }
}

function* onGetLeadConversionPixelAggProfiles(action) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_conversion_pixels_aggregated`,
      { ...(action.payload?.queryParams || {}), group_by_param: 'ad_group_id' },
      {
        Authorization: JSON.parse(user_auth).user.token,
        "account-id": JSON.parse(user_auth).user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getLeadConversionPixelsAggProfilesSuccess(response))
  } catch (error) {
    yield put(getLeadConversionPixelsAggProfilesError(error))
  }
}

function* onGetLeadConversionPixelAggSourceTypes(action) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_conversion_pixels_aggregated`,
      { ...(action.payload?.queryParams || {}), group_by_param: 'source_type_id' },
      {
        Authorization: JSON.parse(user_auth).user.token,
        "account-id": JSON.parse(user_auth).user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getLeadConversionPixelsAggSourceTypesSuccess(response))
  } catch (error) {
    yield put(getLeadConversionPixelsAggSourceTypesError(error))
  }
}

function* onGetCallConversionPixelAggProfiles(action) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/call_conversion_pixels_aggregated`,
      { ...(action.payload?.queryParams || {}), group_by_param: 'ad_group_id' },
      {
        Authorization: JSON.parse(user_auth).user.token,
        "account-id": JSON.parse(user_auth).user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getCallConversionPixelsAggProfilesSuccess(response))
  } catch (error) {
    yield put(getCallConversionPixelsAggProfilesError(error))
  }
}

function* onGetCallConversionPixelAggSourceTypes(action) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/call_conversion_pixels_aggregated`,
      { ...(action.payload?.queryParams || {}), group_by_param: 'source_type_id' },
      {
        Authorization: JSON.parse(user_auth).user.token,
        "account-id": JSON.parse(user_auth).user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getCallConversionPixelsAggSourceTypesSuccess(response))
  } catch (error) {
    yield put(getCallConversionPixelsAggSourceTypesError(error))
  }
}

function* onGetConversionPixelsAggAdGroupsV3(action) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v3/conversion_pixels_aggregated`,
      { ...(action.payload?.queryParams || {}), group_by_param: 'ad_group_id' },
      {
        Authorization: JSON.parse(user_auth).user.token,
        "account-id": JSON.parse(user_auth).user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getConversionPixelsAggAdGroupsV3Success(response))
  } catch (error) {
    yield put(getConversionPixelsAggAdGroupsV3Error(error))
  }
}

function* onGetConversionPixelsAggSourceTypesV3(action) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v3/conversion_pixels_aggregated`,
      { ...(action.payload?.queryParams || {}), group_by_param: 'source_type_id' },
      {
        Authorization: JSON.parse(user_auth).user.token,
        "account-id": JSON.parse(user_auth).user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getConversionPixelsAggSourceTypesV3Success(response))
  } catch (error) {
    yield put(getConversionPixelsAggSourceTypesV3Error(error))
  }
}

function* onGetConversionPixelsAggCampaignsV3(action) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v3/conversion_pixels_aggregated`,
      { ...(action.payload?.queryParams || {}), group_by_param: 'campaign_id' },
      {
        Authorization: JSON.parse(user_auth).user.token,
        "account-id": JSON.parse(user_auth).user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getConversionPixelsAggCampaignsV3Success(response))
  } catch (error) {
    yield put(getConversionPixelsAggCampaignsV3Error(error))
  }
}

function* conversionsSaga() {
  yield takeEvery(GET_CLICK_CONVERSION_PIXELS, onGetClickConversionPixels)
  yield takeEvery(MODIFY_CLICK_CONVERSION_PIXELS, onUpdateClickConversionPixels)
  yield takeEvery(ADD_CLICK_CONVERSION_PIXEL, onAddClickConversionPixel)
  yield takeEvery(DELETE_CLICK_CONVERSION_PIXEL, onDeleteClickConversionPixel)
  yield takeLatest(GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS, onGetClickConversionPixelAggAdGroups)
  yield takeLatest(GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES, onGetClickConversionPixelAggSourceTypes)
  yield takeEvery(ADD_CLICK_IMPORT_CONVERSION_PIXEL, onAddClickImportConversionPixel)
  yield takeLatest(GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS, onGetClickConversionPixelAggCampaigns)
  yield takeLatest(GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS, onGetLeadConversionPixelAggCampaigns)
  yield takeLatest(GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES, onGetLeadConversionPixelAggProfiles)
  yield takeLatest(GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES, onGetLeadConversionPixelAggSourceTypes)
  yield takeLatest(GET_CALL_CONVERSION_PIXELS_AGG_PROFILES, onGetCallConversionPixelAggProfiles)
  yield takeLatest(GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS, onGetCallConversionPixelAggCampaigns)
  yield takeLatest(GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES, onGetCallConversionPixelAggSourceTypes)
  yield takeEvery(GET_CLICK_CONVERSION_LOGS, onGetClickConversionLogs)
  yield takeEvery(GET_CLICK_CONVERSION_LOG_BY_ID, onGetClickConversionLogById)
  yield takeEvery(GET_PRESIGNED_URL, onGetPresignedUrl)
  yield takeEvery(UPLOAD_FILE_TO_URL, onPostFileToPresignedURL)
  yield takeEvery(GET_STATUS_OF_LOGS_BY_IDS, onGetClickConversionLogsStatusByIds)
  yield takeEvery(DOWNLOAD_BULK_CONVERSIONS_FILE, onDownloadBulkConversionsFile)
  yield takeEvery(DELETE_CLICK_CONVERSION_LOG, onDeleteClickConversionLog)
  yield takeEvery(GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3, onGetConversionPixelsAggAdGroupsV3)
  yield takeEvery(GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3, onGetConversionPixelsAggSourceTypesV3)
  yield takeEvery(GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3, onGetConversionPixelsAggCampaignsV3)
}

export default conversionsSaga
